import { createBrowserRouter } from "react-router-dom";

import Layout from "./layouts/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import { DefiDashboard } from "./modules/defi";
import Settings from "./pages/Settings";
import Overview from "./pages/Overview";
import PortfolioOverview from "./pages/PortfolioOverview";
import { AuthorityDashboardView, DependencyGraphView, NucleusDetailView, OpportunityRegistryView } from "./features/portfolio";
import ConnectWalletPage from "./pages/ConnectWalletPage";
import {
  BusinessACS,
  BusinessACSReadiness,
  BusinessAccess,
  BusinessAssetDetail,
  BusinessAssets,
  BusinessDebentures,
  BusinessEvents,
  BusinessFinance,
  BusinessFunding,
  BusinessGovernanceReadiness,
  BusinessIntakePage,
  BusinessOverview,
  BusinessPlugins,
  BusinessProjectDetail,
  BusinessProjects,
  BusinessRegistry,
  BusinessRequests,
  BusinessRevenue,
  BusinessReviewQueue,
  BusinessRisk,
  BusinessRuntime,
  BusinessState,
  BusinessTelemetry,
  BusinessTreasury,
  BusinessWorkflows,
} from "./modules/business";

// Importações dos novos componentes estáticos
import {
  AcademyCertifications,
  AcademyCourseDetails,
  AcademyCourses,
  AcademyDashboard,
  AcademyGovernanceEligibility,
  AcademyGovernanceReview,
  AcademyHome,
  AcademyLearningWorkspace,
  AcademyPathViewer,
  AcademyProgressEngine,
  AcademyRewards,
  AcademyTutorProfile,
} from "./modules/academy";
import {
  MiningAllocations,
  MiningActions,
  MiningAccounting,
  MiningGovernance,
  MiningHashTokens,
  MiningOverview,
  MiningProviderDetails,
  MiningProviders,
  MiningReconciliation,
  MiningReports,
  MiningRisk,
  MiningTelemetry,
  MiningTreasury,
  MiningVaults,
} from "./modules/mining";
import {
  MarketplaceCreateSell,
  MarketplaceAssetGallery,
  MarketplaceDashboard,
  MarketplaceExplore,
  MarketplaceGovernance,
  MarketplaceHome,
  MarketplaceListings,
  MarketplaceLegacyItem,
  MarketplaceLicenses,
  MarketplaceProductDetail,
  MarketplaceOrders,
  MarketplacePublisher,
  MarketplaceSellerProfile,
  MarketplaceSubscriptions,
  MarketplaceTreasury,
} from "./modules/marketplace";
import Dex from "./pages/Dex";
import Mcps from "./pages/Mcps";
import { DaoTenantDetail, GovernanceDashboard, GovernanceLanding, GovernanceReadOnlyProposalListPage, GovernanceTenants, ProposalDetail } from "./modules/governance";
import { BbaCampaigns, BbaGovernance, BbaHome, BbaPartnerships, BbaPortfolio, BbaServices } from "./modules/bba";
import {
  LotteryDashboard,
  LotteryDrawDetails,
  LotteryDrawHistory,
  LotteryDraws,
  LotteryGameModels,
  LotteryGovernance,
  LotteryPrizePools,
  LotteryRandomness,
  LotteryTickets,
} from "./modules/lottery";
import {
  AcsCapabilities,
  AcsOverview,
  AcsPolicy,
  AcsPolicyDebug,
  AcsProducts,
  AcsReadiness,
  AcsStatus,
  AcsTenantServices,
} from "./modules/acs";


const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Overview /> },
      { path: "connect", element: <ConnectWalletPage /> },
      { path: "portfolio", element: <PortfolioOverview /> },
      { path: "portfolio/dependencies", element: <DependencyGraphView /> },
      { path: "portfolio/opportunities", element: <OpportunityRegistryView /> },
      { path: "portfolio/authority", element: <AuthorityDashboardView /> },
      { path: "portfolio/:nucleusId", element: <NucleusDetailView /> },
      { path: "account", element: <BusinessOverview /> },
      { path: "business", element: <BusinessOverview /> },
      { path: "business/intake", element: <BusinessIntakePage /> },
      { path: "business/intake/new", element: <BusinessIntakePage /> },
      { path: "business/intake/dao-plugin", element: <BusinessIntakePage /> },
      { path: "business/intake/acs-service", element: <BusinessIntakePage /> },
      { path: "business/intake/treasury-sponsorship", element: <BusinessIntakePage /> },
      { path: "business/intake/debenture-funding", element: <BusinessIntakePage /> },
      { path: "business/intake/preview", element: <BusinessIntakePage /> },
      { path: "business/intake/preview/:draftId", element: <BusinessIntakePage /> },
      { path: "business/intake/drafts", element: <BusinessIntakePage /> },
      { path: "business/intake/drafts/:draftId", element: <BusinessIntakePage /> },
      { path: "business/review-queue", element: <BusinessReviewQueue /> },
      { path: "business/requests", element: <BusinessRequests /> },
      { path: "business/projects", element: <BusinessProjects /> },
      { path: "business/projects/:projectId", element: <BusinessProjectDetail /> },
      { path: "business/assets", element: <BusinessAssets /> },
      { path: "business/assets/:assetId", element: <BusinessAssetDetail /> },
      { path: "business/registry", element: <BusinessRegistry /> },
      { path: "business/workflows", element: <BusinessWorkflows /> },
      { path: "business/events", element: <BusinessEvents /> },
      { path: "business/state", element: <BusinessState /> },
      { path: "business/risk", element: <BusinessRisk /> },
      { path: "business/runtime", element: <BusinessRuntime /> },
      { path: "business/access", element: <BusinessAccess /> },
      { path: "business/governance", element: <BusinessGovernanceReadiness /> },
      { path: "business/finance", element: <BusinessFinance /> },
      { path: "business/identity", element: <BusinessAccess /> },
      { path: "business/permissions", element: <BusinessAccess /> },
      { path: "business/capabilities", element: <BusinessAccess /> },
      { path: "business/plugins", element: <BusinessPlugins /> },
      { path: "business/funding", element: <BusinessFunding /> },
      { path: "business/debentures", element: <BusinessDebentures /> },
      { path: "business/treasury", element: <BusinessTreasury /> },
      { path: "business/revenue", element: <BusinessRevenue /> },
      { path: "business/acs", element: <BusinessACS /> },
      { path: "business/acs/readiness", element: <BusinessACSReadiness /> },
      { path: "business/telemetry", element: <BusinessTelemetry /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "defi", element: <DefiDashboard /> },
      { path: "settings", element: <Settings /> },
      { path: "governance", element: <GovernanceLanding /> },
      { path: "governance/overview", element: <GovernanceLanding /> },
      { path: "governance/tenants", element: <GovernanceTenants /> },
      { path: "governance/dao/:daoId", element: <DaoTenantDetail /> },
      { path: "governance/console", element: <ProtectedRoute><GovernanceDashboard /></ProtectedRoute> },
      { path: "governance/proposals", element: <ProtectedRoute><GovernanceReadOnlyProposalListPage /></ProtectedRoute> },
      { path: "governance/proposals/:proposalId", element: <ProtectedRoute><ProposalDetail /></ProtectedRoute> },
      { path: "dao", element: <ProtectedRoute><GovernanceDashboard /></ProtectedRoute> },
      { path: "mining", element: <MiningOverview /> },
      { path: "mining/providers", element: <MiningProviders /> },
      { path: "mining/providers/:providerSlug", element: <MiningProviderDetails /> },
      { path: "mining/hash-tokens", element: <MiningHashTokens /> },
      { path: "mining/vaults", element: <MiningVaults /> },
      { path: "mining/allocations", element: <MiningAllocations /> },
      { path: "mining/telemetry", element: <MiningTelemetry /> },
      { path: "mining/treasury", element: <MiningTreasury /> },
      { path: "mining/accounting", element: <MiningAccounting /> },
      { path: "mining/reconciliation", element: <MiningReconciliation /> },
      { path: "mining/risk", element: <MiningRisk /> },
      { path: "mining/governance", element: <MiningGovernance /> },
      { path: "mining/actions", element: <MiningActions /> },
      { path: "mining/reports", element: <MiningReports /> },
      { path: "marketplace", element: <MarketplaceHome /> },
      { path: "marketplace/explore", element: <MarketplaceExplore /> },
      { path: "marketplace/assets", element: <MarketplaceAssetGallery /> },
      { path: "marketplace/listings", element: <MarketplaceListings /> },
      { path: "marketplace/create", element: <MarketplaceCreateSell /> },
      { path: "marketplace/sell", element: <MarketplaceCreateSell /> },
      { path: "marketplace/products/:slug", element: <MarketplaceProductDetail /> },
      { path: "marketplace/sellers/:sellerId", element: <MarketplaceSellerProfile /> },
      { path: "marketplace/orders", element: <ProtectedRoute><MarketplaceOrders /></ProtectedRoute> },
      { path: "marketplace/subscriptions", element: <ProtectedRoute><MarketplaceSubscriptions /></ProtectedRoute> },
      { path: "marketplace/treasury", element: <ProtectedRoute><MarketplaceTreasury /></ProtectedRoute> },
      { path: "marketplace/publisher", element: <ProtectedRoute><MarketplacePublisher /></ProtectedRoute> },
      { path: "marketplace/governance", element: <MarketplaceGovernance /> },
      { path: "marketplace/licenses", element: <MarketplaceLicenses /> },
      { path: "marketplace/dashboard", element: <MarketplaceDashboard /> },
      { path: "item/:chain/:contract/:id", element: <MarketplaceLegacyItem /> },
      { path: "academy", element: <AcademyHome /> },
      { path: "academy/courses", element: <AcademyCourses /> },
      { path: "academy/courses/:courseSlug", element: <AcademyCourseDetails /> },
      { path: "academy/workspace/:courseSlug", element: <AcademyLearningWorkspace /> },
      { path: "academy/dashboard", element: <AcademyDashboard /> },
      { path: "academy/progress", element: <AcademyProgressEngine /> },
      { path: "academy/eligibility", element: <AcademyGovernanceEligibility /> },
      { path: "academy/tutors/:tutorId", element: <AcademyTutorProfile /> },
      { path: "academy/certifications", element: <AcademyCertifications /> },
      { path: "academy/rewards", element: <AcademyRewards /> },
      { path: "academy/governance-review", element: <AcademyGovernanceReview /> },
      { path: "academy/paths/:pathId", element: <AcademyPathViewer /> },
      { path: "dex", element: <Dex /> },
      { path: "lottery", element: <LotteryDashboard /> },
      { path: "lottery/draws", element: <LotteryDraws /> },
      { path: "lottery/draws/:slug", element: <LotteryDrawDetails /> },
      { path: "lottery/game-models", element: <LotteryGameModels /> },
      { path: "lottery/tickets", element: <LotteryTickets /> },
      { path: "lottery/prizes", element: <LotteryPrizePools /> },
      { path: "lottery/governance", element: <LotteryGovernance /> },
      { path: "lottery/randomness", element: <LotteryRandomness /> },
      { path: "lottery/history", element: <LotteryDrawHistory /> },
      { path: "bba", element: <BbaHome /> },
      { path: "bba/services", element: <BbaServices /> },
      { path: "bba/portfolio", element: <BbaPortfolio /> },
      { path: "bba/campaigns", element: <BbaCampaigns /> },
      { path: "bba/partnerships", element: <BbaPartnerships /> },
      { path: "bba/governance", element: <BbaGovernance /> },
      { path: "acs", element: <AcsOverview /> },
      { path: "acs/capabilities", element: <AcsCapabilities /> },
      { path: "acs/services", element: <AcsTenantServices /> },
      { path: "acs/products", element: <AcsProducts /> },
      { path: "acs/policy", element: <AcsPolicy /> },
      { path: "acs/debug", element: <AcsPolicyDebug /> },
      { path: "acs/status", element: <AcsStatus /> },
      { path: "acs/readiness", element: <AcsReadiness /> },
      { path: "mcps", element: <Mcps /> },
    ],
  },

]);

export default router;
